import { memo } from 'react';
import { useRefinementList } from 'react-instantsearch';

import { useRouter } from '@/hooks/useRouter';
import { generateDataTestId } from '@/lib/tests';

import * as S from './CollectionsList.styles';

export const CollectionsList = memo(() => {
  const { paths } = useRouter();
  const { items } = useRefinementList({
    attribute: 'collection',
  });

  return (
    <S.SuggestedSearch
      {...generateDataTestId('section', 'suggestedSearch')}
      data-test-id='CollectionsListSuggestedSearch'
    >
      {items?.map((item, index) => (
        <S.CollectionContainer
          key={item.value}
          data-test-id={`CollectionsListCollectionContainer-${index}`}
        >
          <S.StyledLink
            data-test-id={`CollectionsListStyledLink-${index}`}
            href={{
              ...paths.search.watches.url(),
              query: { q: item.value },
            }}
          >
            {item.label}
          </S.StyledLink>
        </S.CollectionContainer>
      ))}
    </S.SuggestedSearch>
  );
});

CollectionsList.displayName = 'CollectionsList';
